<template>
  <div>
    <md-dialog
      v-model="kycVisible"
      :closable="false"
      :btns="btns"
    >
      {{ $t('please_raise_your_kyc') }}
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import { mapMutations } from 'vuex'
export default {
  name: 'KYCDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      btns: [
        {
          text: this.$t('cancel'),
          handler: this.onBasicCancel
        },
        {
          text: this.$t('raise_my_kyc_level'),
          handler: this.onBasicConfirm
        }
      ]
    }
  },
  computed: {
    kycVisible: {
      get () {
        return this.$store.state.kycVisible
      },
      set () {}
    }
  },
  methods: {
    ...mapMutations(['change_kycVisible']),
    onBasicConfirm () { // 确认按钮
      this.$router.push({ name: 'ActivateHighLevel' })
      this.change_kycVisible(false)
    },
    onBasicCancel () { // 取消按钮
      this.change_kycVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: center;
  line-height: 48px;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
